/* tslint:disable:no-any */
import { getInterfaceNoMethodsErrorMsg, getInterfaceWrongDomainErrorMsg } from './errorMessages';
import { ServiceMeta } from './ServiceMeta';

export function Interface(domain: string, name: string, schema?: string | object) {
  return (target: any) => {
    if (!domain || typeof domain !== 'string') {
      throw new Error(getInterfaceWrongDomainErrorMsg());
    }

    const meta = ServiceMeta.getOrThrow(target.prototype, getInterfaceNoMethodsErrorMsg(target.name));
    meta.serviceName = name || target.name;
    meta.domain = domain;

    if (schema) {
      const s = typeof schema === 'string' ? JSON.parse(schema) : schema;

      meta.methods.forEach((m) => {
        if (s[m.name]) {
          Object.assign(m, s[m.name]);
        }
      });

      meta.events.forEach((e) => {
        if (s[e.name]) {
          Object.assign(e, s[e.name]);
        }
      });
    }
  };
}
